import { render, staticRenderFns } from "./module-bar.vue?vue&type=template&id=90235540&scoped=true&"
import script from "./module-bar.vue?vue&type=script&lang=js&"
export * from "./module-bar.vue?vue&type=script&lang=js&"
import style0 from "./module-bar.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./module-bar.vue?vue&type=style&index=1&id=90235540&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90235540",
  null
  
)

export default component.exports